export enum DeviceBatteryState {
	Charging = 'CHARGING',
	Full = 'FULL',
	Discharging = 'DISCHARGING',
	Empty = 'EMPTY',
	OptimalStorage = 'OPTIMAL_STORAGE',
	Calculating = 'CALCULATING'
}
